import { Component } from '@angular/core';

@Component({
    selector: 'app-termsofuse',
    standalone: true,
    templateUrl: './termsofuse.component.html',
    styleUrl: './termsofuse.component.scss',
})
export class TermsofuseComponent {
    public links = [
        { href: 'https://agi.aero/termsofuse', text: 'AGI Terms of Use' },
        {
            href: 'https://cargosprint.com/legal/terms-of-use',
            text: 'CargoSprint',
        },
        { href: 'https://www.paypal.com/va/legalhub/useragreement-full', text: 'PayPal' },
    ];
}
